import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {environment} from "../../../../../environments/environment";
import {NavController} from "@ionic/angular";

@Component({
  selector: 'app-ion-common-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  
  private clicks=0;
  private clicksTotal=10;
  private timeout=3000;
  private timer;
  
  @Input() id = 'header-back';
  @Input() labelBtnBack = 'voltar';
  @Input() title = '';
  @Input() start = '';
  @Input() end = '';
  @Input() close;
  @Output() backHeader = new EventEmitter();
  @Output() focusHeader = new EventEmitter();

  constructor(public router: NavController) {
  }

  clickLabel(){

    if(!environment.production || environment.id === 'dev' || environment.id === 'staging'){
      if(!this.timer){
        setTimeout(() => {
          this.clicks = 0;
          clearTimeout(this.timer);
        }, this.timeout);
      }

      this.clicks++;
      if(this.clicks>=this.clicksTotal){
        this.clicks = 0;
        clearTimeout(this.timer);
        this.router.navigateForward('tools/settings');
      }

    }

  }


  back($event: any) {
    $event.preventDefault();
    $event.stopPropagation();
    this.backHeader.emit();
  }

}
